import type { IconPlatform } from './types';

export const PlatformImgIcon = ({
  imageName,
  platform = 'salesforce',
  width = '24px',
  height = '24px',
}: {
  imageName: string;
  platform?: IconPlatform;
  width?: string;
  height?: string;
}) => {
  return (
    <img style={{ width, height }} src={`/icons/${platform}/${imageName}.svg`} alt={imageName} />
  );
};
